import { apiClient, readBoundedString, readRecord, readString } from "@/shared/http";

export type ServerInfo = {
  environment: "local" | "dev" | "prod";
  version: string;
};

/** 배포 정보도 외부 입력이므로 계약을 확인한 뒤 화면에 전달한다. */
export async function getServerInfo(signal: AbortSignal): Promise<ServerInfo> {
  const response = await apiClient.get<unknown>("/v1/server-info", { signal });
  const body = readRecord(response.data, "server-info", "body");
  return {
    environment: readBoundedString(
      body.environment,
      ["local", "dev", "prod"] as const,
      "server-info",
      "environment",
    ),
    version: readString(body.version, "server-info", "version"),
  };
}
